<mat-icon [ngStyle]="getStyles()" [title]="title | transloco">
  {{ getIcon() }}
</mat-icon>
